import { Link, useRouterState } from "@tanstack/react-router";
import {
  CalendarCheck,
  ClipboardList,
  Compass,
  Crosshair,
  LayoutDashboard,
  Radar,
  Wrench,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { useOverlayOpen } from "@/lib/overlay-store";

const ITEMS = [
  { to: "/", label: "Home", icon: LayoutDashboard },
  { to: "/revisions", label: "Revision", icon: CalendarCheck },
  { to: "/questions", label: "Questions", icon: ClipboardList },
  { to: "/tests", label: "Tests", icon: Crosshair },
  { to: "/pyq-predictor", label: "PYQ Predictor", icon: Compass },
  { to: "/toolkit", label: "Toolkit", icon: Wrench },
  { to: "/tracker-360", label: "Tracker 360", icon: Radar },
] as const;

/** Desktop-only top navigation. The bottom bar stays the mobile experience. */
export function DesktopNav() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const overlayOpen = useOverlayOpen();

  return (
    <header
      aria-hidden={overlayOpen}
      className={cn(
        "sticky top-0 z-40 hidden w-full border-b border-hairline bg-background/80 backdrop-blur-xl transition-opacity duration-300 lg:block",
        overlayOpen && "pointer-events-none opacity-0",
      )}
    >
      <div className="page-shell flex items-center gap-6 px-8 py-3">
        <Link
          to="/"
          className="shrink-0 text-[15px] font-extrabold tracking-tight text-foreground"
        >
          The Quantum MIND
        </Link>
        <nav className="flex min-w-0 flex-1 items-center gap-1">
          {ITEMS.map((item) => {
            const active =
              item.to === "/" ? pathname === "/" : pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={cn(
                  "flex items-center gap-2 rounded-xl px-3 py-1.5 text-[12.5px] font-semibold transition-colors",
                  active
                    ? "bg-primary/12 text-primary"
                    : "text-muted-foreground hover:bg-surface hover:text-foreground",
                )}
              >
                <item.icon className="size-3.5 shrink-0" />
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
